/**
 * Салбарын размер бүрийн нөөц — «аль размер дуусч байна вэ».
 *
 * Салбарын ажилтан өдөр бүр асуудаг: «40 размер хэд үлдсэн, агуулахаас
 * татах уу». Энэ файл нь ТЭР асуултын ЦОРЫН ГАНЦ хариулт — сервер
 * (`/reports/branch-dashboard`), вэбийн мэдэгдлийн хонх хоёулаа ижил
 * дүрмээр «бага» гэж шийднэ.
 *
 * ДҮРЭМ
 *  · дууссан — салбарт 0 ширхэг
 *  · бага    — `LOW_STOCK_UNITS` (2) ба түүнээс цөөн, ЭСВЭЛ сүүлийн
 *              30 хоногийн хурдаар `LOW_STOCK_COVER_DAYS`-аас өмнө
 *              дуусна. Хоёр дахь нь их зарагддаг размерыг
 *              эрт барина: сард 12 зарагддаг размерт 4 үлдвэл
 *              «4 бол олон» биш — 10 хоногт дуусна.
 *
 * ⚠️ Хоёр тогтмол нь БИЗНЕСИЙН ШИЙДВЭР. Эзэмшигч өөрчилж болно —
 *    өөрчлөхөд тестийг хамт зас.
 *
 * ⚠️ Зөвхөн «хөдөлж буй» размерыг ХЯНАНА: салбарт байгаа, эсвэл
 *    сүүлийн 30 хоногт тэнд зарагдсан. Агуулахад л байгаа (энэ
 *    салбар хэзээ ч зарж байгаагүй) размерыг «дууссан» гэвэл
 *    хүүхдийн 28 размер эрэгтэйчүүдийн салбарт үүрд анхааруулга
 *    болно.
 */
/** Үүнээс цөөн (тэнцүү) үлдвэл «бага». */
export const LOW_STOCK_UNITS = 2;
/** Одоогийн хурдаар үүнээс өмнө дуусах бол «бага». */
export const LOW_STOCK_COVER_DAYS = 14;
/** Борлуулалтын хурдыг хэмжих цонх — сервер яг ийм хугацааны мөр өгнө. */
export const SALES_WINDOW_DAYS = 30;
/**
 * Одоогийн хурдаар хэдэн хоногт дуусах вэ. Зарагдаагүй бол null —
 * «хязгааргүй» гэдгийг тоогоор хэлж чадахгүй.
 */
export function coverDays(onHand, sold) {
    if (sold <= 0)
        return null;
    return Math.floor((onHand * SALES_WINDOW_DAYS) / sold);
}
export function stockLevel(onHand, sold) {
    if (onHand <= 0)
        return 'out';
    if (onHand <= LOW_STOCK_UNITS)
        return 'low';
    const days = coverDays(onHand, sold);
    return days !== null && days < LOW_STOCK_COVER_DAYS ? 'low' : 'ok';
}
/** Размер өсөхөөр, размергүй (NULL) нь төгсгөлд. */
export function compareSize(a, b) {
    if (a === b)
        return 0;
    if (a === null)
        return 1;
    if (b === null)
        return -1;
    return a - b;
}
/**
 * Гурван тоолуурыг размераар нийлүүлж мөр болгоно.
 *
 * Хяналтад орох размер = салбарт байгаа ∪ сүүлд зарагдсан. Размергүй
 * гутал салбарт байвал мөр гарна, гэхдээ «бага» гэж хэзээ ч
 * тэмдэглэгдэхгүй — ямар размер татахаа хэлж чадахгүй.
 * Эрэмбэ: размер өсөхөөр, размергүй нь төгсгөлд.
 */
export function sizeStockRows(input) {
    const sizes = new Set();
    for (const [size, n] of input.onHand)
        if (n > 0)
            sizes.add(size);
    for (const [size, n] of input.sold)
        if (n > 0 && size !== null)
            sizes.add(size);
    return [...sizes]
        .sort(compareSize)
        .map((size) => {
        const onHand = input.onHand.get(size) ?? 0;
        const sold = input.sold.get(size) ?? 0;
        return {
            size,
            onHand,
            warehouse: input.warehouse.get(size) ?? 0,
            sold,
            coverDays: coverDays(onHand, sold),
            level: size === null ? 'ok' : stockLevel(onHand, sold),
        };
    });
}
//# sourceMappingURL=size-stock.js.map